// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2IEEh","description":"PatientConsentPreview_description__Gkm7h"};